import React from 'react';
import { MdOutlineChevronLeft, MdOutlineChevronRight } from 'react-icons/md';

import { toast } from 'react-toastify';
import Button from '../../UI/Button';
import classes from './Pagination.module.css';
const Pagination = ({ page = 1, setPage, limit, totalCount }) => {

  const totalNoOfPages = Math.ceil(totalCount / limit);
  return (
    <div className={[classes.wrapper].join(' ')}>
      <Button
        variants="pageBtn"
        onClick={() => {
          if (page > 1) {
            setPage(page - 1);
          } else {
            toast.warn('Value should be greater than 0 ');
          }
        }}
        className={['align_grid_1rem_gap', 'button_transparent'].join(' ')}>
        <MdOutlineChevronLeft className={classes.shrink0} size={23} color="var(--icon-color)" />
        <span className={classes['indicator__name']}>Back</span>
      </Button>
      <div className={classes.controlGroup}>
        <input
          type={'number'}
          className={[classes.inputBox].join(' ')}
          value={page}
          onChange={(e) => {
            const value = +e?.target?.value;
            if (value < 0) {
              toast.warn('Page Should be greater than 0');
              setPage(0);
              return 0;
            } else if (value > totalNoOfPages) {
              toast.warn('Page is greater than total no of pages');
              setPage(0);
              return 0;
            }
            setPage(value);
          }}
          style={{
            background: 'var(--white-color)',
            color: 'var(--icon-color)',
            textAlign: 'center'
          }}
          placeholder=""
          min="1"
          max={totalNoOfPages}
        />
        <p className={[classes['indicator__outof'], 'font-medium'].join(' ')}>
          of {isNaN(totalNoOfPages) ? 0 : totalNoOfPages}
        </p>
      </div>
      <Button
        variants="pageBtn"
        onClick={() => {
          if (page < totalNoOfPages) {
            setPage(+page + 1);
          } else {
            toast.warn('Value should be less than total pages ');
          }
        }}
        className={['align_grid_1rem_gap', 'button_transparent', classes.paginationBtn].join(' ')}>
        <span className={classes['indicator__name']}>Next</span>
        <MdOutlineChevronRight className={classes.shrink0} size={23} color="var(--icon-color)" />
      </Button>
    </div>
  );
};

export default Pagination;
